import { Link, useLocation } from 'react-router-dom'
import { getPortalSectionsForNav } from '@/lib/adminPortal'

interface AdminPortalNavProps {
  isAdmin: boolean
}

/**
 * Portal navigation: sidebar list of sections. Moderators see only non-admin-only sections.
 * Uses aria-current="page" for current route; keyboard-accessible.
 */
export default function AdminPortalNav({ isAdmin }: AdminPortalNavProps) {
  const location = useLocation()
  const sections = getPortalSectionsForNav(isAdmin)

  return (
    <nav aria-label="Admin portal navigation" className="flex flex-col gap-1">
      <ul className="list-none p-0 m-0 flex flex-col gap-1">
        {sections.map((section) => {
          const isCurrent = location.pathname === section.path
          return (
            <li key={section.id}>
              <Link
                to={section.path}
                className="block px-4 py-2 rounded min-h-[44px] flex items-center"
                style={{
                  color: 'var(--text-primary)',
                  backgroundColor: isCurrent ? 'var(--bg-secondary)' : 'transparent',
                  borderLeft: isCurrent ? '3px solid var(--color-focus)' : '3px solid transparent',
                  textDecoration: 'none',
                }}
                aria-current={isCurrent ? 'page' : undefined}
              >
                {section.label}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
